/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CaptureBookingCtaClickParams,
  DefineAgelessAssessmentForAnonymousPersonRequest,
  DefineAgelessAssessmentForPersonResponse,
  DefineAgelessAssessmentRequest,
  DefineAgelessAssessmentResponse,
  DisplayAestheticRecommendationsForAssessmentResponse,
  DisplayAgelessAssessment,
  DisplayAgelessAssessmentConsultationStatusResponse,
  DisplayAgelessAssessmentContactLeadSourcesResponse,
  DisplayAgelessAssessmentContactPrefill,
  DisplayAssessmentOutreachSettingsResponse,
  DisplayWellnessRecommendationsForAssessmentResponse,
  GenerateAfterImageBody,
  PagedAgelessAssessmentsForListViewResponse,
  PagedAgelessAssessmentsResponse,
  ProblemDetails,
  RecordAssessmentExperimentAssignmentRequest,
  RequestConsultationForAssessmentRequest,
  RetrieveAestheticRecommendationsParams,
  RetrieveAssessmentFuturePhotoResponse,
  RetrieveJustArrivedAssessmentsForPlatformParams,
  RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  RetrievePagedAssessmentsForPlatformListViewParams,
  RetrievePagedAssessmentsForPlatformParams,
  RetrieveRequestedConsultationAssessmentsForPlatformParams,
  RetrieveV2JustArrivedAssessmentsForPlatformParams,
  RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  RetrieveWellnessRecommendationsParams,
  SetAssessmentContactInfoRequest,
  SetAssessmentContextRequest,
  SetAssessmentEmailRequest,
  SetAssessmentOriginalLanguageRequest,
  SetAssessmentPhotoDeviceInformationRequest,
  SetAssessmentPreScanInformationRequest,
  SetAssessmentSelectedTreatmentsRequest,
  SetAssessmentStepByIdRequest,
} from "../model";

import { retrieveData } from "../../custom-fetch";
import type { ErrorType, BodyType } from "../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAssessmentOutreachSettingsUrl = (platformId: string, assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/platforms/sync/${platformId}/assessments/${assessmentId}/outreach-settings`;
};

/**
 * @summary Returns outreach contactability settings for a specific assessment.
Intended for Customer.io to evaluate long-running campaign eligibility.
 */
export const getAssessmentOutreachSettings = async (
  platformId: string,
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAssessmentOutreachSettingsResponse> => {
  return retrieveData<DisplayAssessmentOutreachSettingsResponse>(
    getGetAssessmentOutreachSettingsUrl(platformId, assessmentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAssessmentOutreachSettingsQueryKey = (
  platformId: string,
  assessmentId: string,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/platforms/sync/${platformId}/assessments/${assessmentId}/outreach-settings`,
  ] as const;
};

export const getGetAssessmentOutreachSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssessmentOutreachSettingsQueryKey(platformId, assessmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>> = ({
    signal,
  }) => getAssessmentOutreachSettings(platformId, assessmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      platformId !== null &&
      platformId !== undefined &&
      assessmentId !== null &&
      assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAssessmentOutreachSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssessmentOutreachSettings>>
>;
export type GetAssessmentOutreachSettingsQueryError = ErrorType<ProblemDetails>;

export function useGetAssessmentOutreachSettings<
  TData = Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  assessmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentOutreachSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentOutreachSettings<
  TData = Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
          TError,
          Awaited<ReturnType<typeof getAssessmentOutreachSettings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAssessmentOutreachSettings<
  TData = Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Returns outreach contactability settings for a specific assessment.
Intended for Customer.io to evaluate long-running campaign eligibility.
 */

export function useGetAssessmentOutreachSettings<
  TData = Awaited<ReturnType<typeof getAssessmentOutreachSettings>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssessmentOutreachSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAssessmentOutreachSettingsQueryOptions(
    platformId,
    assessmentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDefineAssessmentByAnonymousIdUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments`;
};

/**
 * @summary Defines a new Ageless assessment for an anonymous visitor and returns an assessment token.
 */
export const defineAssessmentByAnonymousId = async (
  defineAgelessAssessmentRequest?: DefineAgelessAssessmentRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DefineAgelessAssessmentResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<DefineAgelessAssessmentResponse>(getDefineAssessmentByAnonymousIdUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(defineAgelessAssessmentRequest),
  });
};

export const getDefineAssessmentByAnonymousIdMutationKey = () =>
  ["defineAssessmentByAnonymousId"] as const;

export const getDefineAssessmentByAnonymousIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>,
    TError,
    DefineAssessmentByAnonymousIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>,
  TError,
  DefineAssessmentByAnonymousIdMutationVariables,
  TContext
> => {
  const mutationKey = getDefineAssessmentByAnonymousIdMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>,
    DefineAssessmentByAnonymousIdMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return defineAssessmentByAnonymousId(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DefineAssessmentByAnonymousIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>
>;
export type DefineAssessmentByAnonymousIdMutationBody =
  | BodyType<DefineAgelessAssessmentRequest>
  | undefined;
export type DefineAssessmentByAnonymousIdMutationError = ErrorType<unknown>;
export type DefineAssessmentByAnonymousIdMutationVariables = {
  data?: BodyType<DefineAgelessAssessmentRequest>;
};

/**
 * @summary Defines a new Ageless assessment for an anonymous visitor and returns an assessment token.
 */
export const useDefineAssessmentByAnonymousId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>,
      TError,
      DefineAssessmentByAnonymousIdMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof defineAssessmentByAnonymousId>>,
  TError,
  DefineAssessmentByAnonymousIdMutationVariables,
  TContext
> => {
  return useMutation(getDefineAssessmentByAnonymousIdMutationOptions(options), queryClient);
};
export const getDefineAssessmentForAnonymousPersonUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/define-for-anonymous-person`;
};

/**
 * @summary Defines a prefilled Ageless assessment for an anonymous person, including
optional contact details captured prior to authentication. Returns a token
and a redirect URL that the Ageless web app uses to bootstrap the session.
 */
export const defineAssessmentForAnonymousPerson = async (
  defineAgelessAssessmentForAnonymousPersonRequest?: DefineAgelessAssessmentForAnonymousPersonRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DefineAgelessAssessmentForPersonResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<DefineAgelessAssessmentForPersonResponse>(
    getDefineAssessmentForAnonymousPersonUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
      body: JSON.stringify(defineAgelessAssessmentForAnonymousPersonRequest),
    },
  );
};

export const getDefineAssessmentForAnonymousPersonMutationKey = () =>
  ["defineAssessmentForAnonymousPerson"] as const;

export const getDefineAssessmentForAnonymousPersonMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>,
    TError,
    DefineAssessmentForAnonymousPersonMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>,
  TError,
  DefineAssessmentForAnonymousPersonMutationVariables,
  TContext
> => {
  const mutationKey = getDefineAssessmentForAnonymousPersonMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>,
    DefineAssessmentForAnonymousPersonMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return defineAssessmentForAnonymousPerson(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DefineAssessmentForAnonymousPersonMutationResult = NonNullable<
  Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>
>;
export type DefineAssessmentForAnonymousPersonMutationBody =
  | BodyType<DefineAgelessAssessmentForAnonymousPersonRequest>
  | undefined;
export type DefineAssessmentForAnonymousPersonMutationError = ErrorType<ProblemDetails>;
export type DefineAssessmentForAnonymousPersonMutationVariables = {
  data?: BodyType<DefineAgelessAssessmentForAnonymousPersonRequest>;
};

/**
 * @summary Defines a prefilled Ageless assessment for an anonymous person, including
optional contact details captured prior to authentication. Returns a token
and a redirect URL that the Ageless web app uses to bootstrap the session.
 */
export const useDefineAssessmentForAnonymousPerson = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>,
      TError,
      DefineAssessmentForAnonymousPersonMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof defineAssessmentForAnonymousPerson>>,
  TError,
  DefineAssessmentForAnonymousPersonMutationVariables,
  TContext
> => {
  return useMutation(getDefineAssessmentForAnonymousPersonMutationOptions(options), queryClient);
};
export const getRetrievePagedAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}`;
};

/**
 * @summary Retrieves a paged list of Ageless assessments for a platform.
 */
export const retrievePagedAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsResponse> => {
  return retrieveData<PagedAgelessAssessmentsResponse>(
    getRetrievePagedAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrievePagedAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrievePagedAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrievePagedAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>> = ({
    signal,
  }) => retrievePagedAssessmentsForPlatform(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrievePagedAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>
>;
export type RetrievePagedAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrievePagedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrievePagedAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a paged list of Ageless assessments for a platform.
 */

export function useRetrievePagedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrievePagedAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrievePagedAssessmentsForPlatformListViewUrl = (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/list-view?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/list-view`;
};

/**
 * @summary Retrieves a paged list-view of Ageless assessments for a platform enriched with lead metadata.
 */
export const retrievePagedAssessmentsForPlatformListView = async (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrievePagedAssessmentsForPlatformListViewUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrievePagedAssessmentsForPlatformListViewQueryKey = (
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/list-view`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrievePagedAssessmentsForPlatformListViewQueryOptions = <
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrievePagedAssessmentsForPlatformListViewQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>
  > = ({ signal }) =>
    retrievePagedAssessmentsForPlatformListView(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrievePagedAssessmentsForPlatformListViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>
>;
export type RetrievePagedAssessmentsForPlatformListViewQueryError = ErrorType<unknown>;

export function useRetrievePagedAssessmentsForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrievePagedAssessmentsForPlatformListViewParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a paged list-view of Ageless assessments for a platform enriched with lead metadata.
 */

export function useRetrievePagedAssessmentsForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrievePagedAssessmentsForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrievePagedAssessmentsForPlatformListViewQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveAgelessAssessmentContactLeadSourcesForPlatformUrl = (
  platformId: string,
) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/lead-sources`;
};

/**
 * @summary The contacts list's Source filter options: the captured utm sources of the contacts this admin can see, and
whether the platform has launched a stamped Ageless Ads campaign.
 */
export const retrieveAgelessAssessmentContactLeadSourcesForPlatform = async (
  platformId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessAssessmentContactLeadSourcesResponse> => {
  return retrieveData<DisplayAgelessAssessmentContactLeadSourcesResponse>(
    getRetrieveAgelessAssessmentContactLeadSourcesForPlatformUrl(platformId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryKey = (
  platformId: string,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/lead-sources`,
  ] as const;
};

export const getRetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryKey(platformId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>
  > = ({ signal }) =>
    retrieveAgelessAssessmentContactLeadSourcesForPlatform(platformId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>
>;
export type RetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveAgelessAssessmentContactLeadSourcesForPlatform<
  TData = Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAgelessAssessmentContactLeadSourcesForPlatform<
  TData = Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAgelessAssessmentContactLeadSourcesForPlatform<
  TData = Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The contacts list's Source filter options: the captured utm sources of the contacts this admin can see, and
whether the platform has launched a stamped Ageless Ads campaign.
 */

export function useRetrieveAgelessAssessmentContactLeadSourcesForPlatform<
  TData = Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAgelessAssessmentContactLeadSourcesForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveAgelessAssessmentContactLeadSourcesForPlatformQueryOptions(
    platformId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveJustArrivedAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/just-arrived?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/just-arrived`;
};

/**
 * @summary Retrieves the just-arrived list for Ageless assessments on a platform.
 */
export const retrieveJustArrivedAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveJustArrivedAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveJustArrivedAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/just-arrived`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveJustArrivedAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveJustArrivedAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveJustArrivedAssessmentsForPlatform(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveJustArrivedAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>
>;
export type RetrieveJustArrivedAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveJustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveJustArrivedAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveJustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveJustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the just-arrived list for Ageless assessments on a platform.
 */

export function useRetrieveJustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveJustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveJustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveJustArrivedAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveV2JustArrivedAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/just-arrived?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/just-arrived`;
};

/**
 * @summary Retrieves the v2 just-arrived list for Ageless assessments on a platform.
 */
export const retrieveV2JustArrivedAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveV2JustArrivedAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveV2JustArrivedAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/just-arrived`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveV2JustArrivedAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveV2JustArrivedAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveV2JustArrivedAssessmentsForPlatform(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveV2JustArrivedAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>
>;
export type RetrieveV2JustArrivedAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveV2JustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2JustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2JustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the v2 just-arrived list for Ageless assessments on a platform.
 */

export function useRetrieveV2JustArrivedAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2JustArrivedAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2JustArrivedAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveV2JustArrivedAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveRequestedConsultationAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/requested-consultation?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/requested-consultation`;
};

/**
 * @summary Retrieves the requested-consultation list for Ageless assessments on a platform.
 */
export const retrieveRequestedConsultationAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveRequestedConsultationAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveRequestedConsultationAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/requested-consultation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveRequestedConsultationAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveRequestedConsultationAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveRequestedConsultationAssessmentsForPlatform(platformId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveRequestedConsultationAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>
>;
export type RetrieveRequestedConsultationAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveRequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveRequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveRequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the requested-consultation list for Ageless assessments on a platform.
 */

export function useRetrieveRequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveRequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveRequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveRequestedConsultationAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveV2RequestedConsultationAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/requested-consultation?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/requested-consultation`;
};

/**
 * @summary Retrieves the v2 requested-consultation list for Ageless assessments on a platform.
 */
export const retrieveV2RequestedConsultationAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveV2RequestedConsultationAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveV2RequestedConsultationAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/requested-consultation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveV2RequestedConsultationAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveV2RequestedConsultationAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveV2RequestedConsultationAssessmentsForPlatform(platformId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveV2RequestedConsultationAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>
>;
export type RetrieveV2RequestedConsultationAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveV2RequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2RequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2RequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the v2 requested-consultation list for Ageless assessments on a platform.
 */

export function useRetrieveV2RequestedConsultationAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2RequestedConsultationAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2RequestedConsultationAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveV2RequestedConsultationAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveWaitingOnPatientAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/waiting-on-patient?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/waiting-on-patient`;
};

/**
 * @summary Retrieves the waiting-on-patient list for Ageless assessments on a platform.
 */
export const retrieveWaitingOnPatientAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveWaitingOnPatientAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveWaitingOnPatientAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/waiting-on-patient`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWaitingOnPatientAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWaitingOnPatientAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveWaitingOnPatientAssessmentsForPlatform(platformId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWaitingOnPatientAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>
>;
export type RetrieveWaitingOnPatientAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveWaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveWaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveWaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the waiting-on-patient list for Ageless assessments on a platform.
 */

export function useRetrieveWaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveWaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveWaitingOnPatientAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveV2WaitingOnPatientAssessmentsForPlatformUrl = (
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/waiting-on-patient?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/waiting-on-patient`;
};

/**
 * @summary Retrieves the v2 waiting-on-patient list for Ageless assessments on a platform.
 */
export const retrieveV2WaitingOnPatientAssessmentsForPlatform = async (
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrieveV2WaitingOnPatientAssessmentsForPlatformUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveV2WaitingOnPatientAssessmentsForPlatformQueryKey = (
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/v2/platform/${platformId}/waiting-on-patient`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveV2WaitingOnPatientAssessmentsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveV2WaitingOnPatientAssessmentsForPlatformQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>
  > = ({ signal }) =>
    retrieveV2WaitingOnPatientAssessmentsForPlatform(platformId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveV2WaitingOnPatientAssessmentsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>
>;
export type RetrieveV2WaitingOnPatientAssessmentsForPlatformQueryError = ErrorType<unknown>;

export function useRetrieveV2WaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params: undefined | RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2WaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveV2WaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the v2 waiting-on-patient list for Ageless assessments on a platform.
 */

export function useRetrieveV2WaitingOnPatientAssessmentsForPlatform<
  TData = Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  params?: RetrieveV2WaitingOnPatientAssessmentsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveV2WaitingOnPatientAssessmentsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveV2WaitingOnPatientAssessmentsForPlatformQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrievePagedAssessmentsForPersonForPlatformListViewUrl = (
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/person/${personId}/list-view?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/person/${personId}/list-view`;
};

/**
 * @summary Retrieves a paged list-view of Ageless assessments for a person on a platform enriched with lead metadata.
 */
export const retrievePagedAssessmentsForPersonForPlatformListView = async (
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<PagedAgelessAssessmentsForListViewResponse> => {
  return retrieveData<PagedAgelessAssessmentsForListViewResponse>(
    getRetrievePagedAssessmentsForPersonForPlatformListViewUrl(platformId, personId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrievePagedAssessmentsForPersonForPlatformListViewQueryKey = (
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/platform/${platformId}/person/${personId}/list-view`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrievePagedAssessmentsForPersonForPlatformListViewQueryOptions = <
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrievePagedAssessmentsForPersonForPlatformListViewQueryKey(platformId, personId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>
  > = ({ signal }) =>
    retrievePagedAssessmentsForPersonForPlatformListView(platformId, personId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      platformId !== null &&
      platformId !== undefined &&
      personId !== null &&
      personId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrievePagedAssessmentsForPersonForPlatformListViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>
>;
export type RetrievePagedAssessmentsForPersonForPlatformListViewQueryError = ErrorType<unknown>;

export function useRetrievePagedAssessmentsForPersonForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  personId: string,
  params: undefined | RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPersonForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrievePagedAssessmentsForPersonForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a paged list-view of Ageless assessments for a person on a platform enriched with lead metadata.
 */

export function useRetrievePagedAssessmentsForPersonForPlatformListView<
  TData = Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
  TError = ErrorType<unknown>,
>(
  platformId: string,
  personId: string,
  params?: RetrievePagedAssessmentsForPersonForPlatformListViewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrievePagedAssessmentsForPersonForPlatformListView>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrievePagedAssessmentsForPersonForPlatformListViewQueryOptions(
    platformId,
    personId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveConsultationStatusUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/consultation-status`;
};

/**
 * @summary Retrieves consultation request status for an Ageless assessment.
 */
export const retrieveConsultationStatus = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessAssessmentConsultationStatusResponse> => {
  return retrieveData<DisplayAgelessAssessmentConsultationStatusResponse>(
    getRetrieveConsultationStatusUrl(assessmentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveConsultationStatusQueryKey = (assessmentId: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/consultation-status`,
  ] as const;
};

export const getRetrieveConsultationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveConsultationStatus>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveConsultationStatusQueryKey(assessmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveConsultationStatus>>> = ({
    signal,
  }) => retrieveConsultationStatus(assessmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RetrieveConsultationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveConsultationStatus>>
>;
export type RetrieveConsultationStatusQueryError = ErrorType<unknown>;

export function useRetrieveConsultationStatus<
  TData = Awaited<ReturnType<typeof retrieveConsultationStatus>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveConsultationStatus>>,
          TError,
          Awaited<ReturnType<typeof retrieveConsultationStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveConsultationStatus<
  TData = Awaited<ReturnType<typeof retrieveConsultationStatus>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveConsultationStatus>>,
          TError,
          Awaited<ReturnType<typeof retrieveConsultationStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveConsultationStatus<
  TData = Awaited<ReturnType<typeof retrieveConsultationStatus>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves consultation request status for an Ageless assessment.
 */

export function useRetrieveConsultationStatus<
  TData = Awaited<ReturnType<typeof retrieveConsultationStatus>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveConsultationStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveConsultationStatusQueryOptions(assessmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveAssessmentByIdUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}`;
};

/**
 * @summary Retrieves an Ageless assessment by its ID.
Should be behind authorization
 */
export const retrieveAssessmentById = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessAssessment> => {
  return retrieveData<DisplayAgelessAssessment>(getRetrieveAssessmentByIdUrl(assessmentId), {
    ...options,
    method: "GET",
  });
};

export const getRetrieveAssessmentByIdQueryKey = (assessmentId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}`] as const;
};

export const getRetrieveAssessmentByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveAssessmentById>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveAssessmentByIdQueryKey(assessmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveAssessmentById>>> = ({ signal }) =>
    retrieveAssessmentById(assessmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RetrieveAssessmentByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveAssessmentById>>
>;
export type RetrieveAssessmentByIdQueryError = ErrorType<unknown>;

export function useRetrieveAssessmentById<
  TData = Awaited<ReturnType<typeof retrieveAssessmentById>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAssessmentById>>,
          TError,
          Awaited<ReturnType<typeof retrieveAssessmentById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAssessmentById<
  TData = Awaited<ReturnType<typeof retrieveAssessmentById>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAssessmentById>>,
          TError,
          Awaited<ReturnType<typeof retrieveAssessmentById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAssessmentById<
  TData = Awaited<ReturnType<typeof retrieveAssessmentById>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves an Ageless assessment by its ID.
Should be behind authorization
 */

export function useRetrieveAssessmentById<
  TData = Awaited<ReturnType<typeof retrieveAssessmentById>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAssessmentById>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveAssessmentByIdQueryOptions(assessmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveCurrentAssessmentUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/current`;
};

/**
 * @summary Retrieves the current assessment for the authenticated assessment token holder.
 */
export const retrieveCurrentAssessment = async (
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessAssessment> => {
  return retrieveData<DisplayAgelessAssessment>(getRetrieveCurrentAssessmentUrl(), {
    ...options,
    method: "GET",
  });
};

export const getRetrieveCurrentAssessmentQueryKey = () => {
  return [`https://admin.ageless.ai/api/v1/ageless/assessments/current`] as const;
};

export const getRetrieveCurrentAssessmentQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof retrieveCurrentAssessment>>, TError, TData>
  >;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveCurrentAssessmentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveCurrentAssessment>>> = ({
    signal,
  }) => retrieveCurrentAssessment({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveCurrentAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveCurrentAssessment>>
>;
export type RetrieveCurrentAssessmentQueryError = ErrorType<unknown>;

export function useRetrieveCurrentAssessment<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveCurrentAssessment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
          TError,
          Awaited<ReturnType<typeof retrieveCurrentAssessment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveCurrentAssessment<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveCurrentAssessment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
          TError,
          Awaited<ReturnType<typeof retrieveCurrentAssessment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveCurrentAssessment<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveCurrentAssessment>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the current assessment for the authenticated assessment token holder.
 */

export function useRetrieveCurrentAssessment<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessment>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveCurrentAssessment>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveCurrentAssessmentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveCurrentAssessmentContactPrefillUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/current/contact-prefill`;
};

/**
 * @summary Retrieves contact prefill data for the authenticated assessment token holder.
Returned as a dedicated payload (not on RestAPI.Contract.WellnessJourneyService.Responses.AgelessAssessments.DisplayAgelessAssessment)
so that share-token replays against the broadly-fetched current-assessment
endpoint cannot disclose this PII. The verify-info form in AgelessAI calls
this endpoint to prefill the contact step for known-person hand-offs.
 */
export const retrieveCurrentAssessmentContactPrefill = async (
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessAssessmentContactPrefill> => {
  return retrieveData<DisplayAgelessAssessmentContactPrefill>(
    getRetrieveCurrentAssessmentContactPrefillUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveCurrentAssessmentContactPrefillQueryKey = () => {
  return [`https://admin.ageless.ai/api/v1/ageless/assessments/current/contact-prefill`] as const;
};

export const getRetrieveCurrentAssessmentContactPrefillQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveCurrentAssessmentContactPrefillQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>
  > = ({ signal }) => retrieveCurrentAssessmentContactPrefill({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveCurrentAssessmentContactPrefillQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>
>;
export type RetrieveCurrentAssessmentContactPrefillQueryError = ErrorType<ProblemDetails>;

export function useRetrieveCurrentAssessmentContactPrefill<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
          TError,
          Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveCurrentAssessmentContactPrefill<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
          TError,
          Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveCurrentAssessmentContactPrefill<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves contact prefill data for the authenticated assessment token holder.
Returned as a dedicated payload (not on RestAPI.Contract.WellnessJourneyService.Responses.AgelessAssessments.DisplayAgelessAssessment)
so that share-token replays against the broadly-fetched current-assessment
endpoint cannot disclose this PII. The verify-info form in AgelessAI calls
this endpoint to prefill the contact step for known-person hand-offs.
 */

export function useRetrieveCurrentAssessmentContactPrefill<
  TData = Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveCurrentAssessmentContactPrefill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveCurrentAssessmentContactPrefillQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetCurrentAssessmentEmailUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/current/email`;
};

/**
 * @summary Captures an email address for the current assessment ahead of the contact step. Used by the
email-pre-scan experiment to persist the email the moment it is entered (so it is captured even
if the taker abandons before the contact form, and prefills that form on arrival).
 */
export const setCurrentAssessmentEmail = async (
  setAssessmentEmailRequest?: SetAssessmentEmailRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetCurrentAssessmentEmailUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentEmailRequest),
  });
};

export const getSetCurrentAssessmentEmailMutationKey = () => ["setCurrentAssessmentEmail"] as const;

export const getSetCurrentAssessmentEmailMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCurrentAssessmentEmail>>,
    TError,
    SetCurrentAssessmentEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCurrentAssessmentEmail>>,
  TError,
  SetCurrentAssessmentEmailMutationVariables,
  TContext
> => {
  const mutationKey = getSetCurrentAssessmentEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCurrentAssessmentEmail>>,
    SetCurrentAssessmentEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setCurrentAssessmentEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCurrentAssessmentEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCurrentAssessmentEmail>>
>;
export type SetCurrentAssessmentEmailMutationBody = BodyType<SetAssessmentEmailRequest> | undefined;
export type SetCurrentAssessmentEmailMutationError = ErrorType<ProblemDetails>;
export type SetCurrentAssessmentEmailMutationVariables = {
  data?: BodyType<SetAssessmentEmailRequest>;
};

/**
 * @summary Captures an email address for the current assessment ahead of the contact step. Used by the
email-pre-scan experiment to persist the email the moment it is entered (so it is captured even
if the taker abandons before the contact form, and prefills that form on arrival).
 */
export const useSetCurrentAssessmentEmail = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setCurrentAssessmentEmail>>,
      TError,
      SetCurrentAssessmentEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setCurrentAssessmentEmail>>,
  TError,
  SetCurrentAssessmentEmailMutationVariables,
  TContext
> => {
  return useMutation(getSetCurrentAssessmentEmailMutationOptions(options), queryClient);
};
export const getRecordCurrentAssessmentExperimentAssignmentUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/current/experiments`;
};

/**
 * @summary Records the variant the current assessment was bucketed into for an experiment. First-write-wins
per experiment; the accumulated set is stored on the assessment for later analysis.
 */
export const recordCurrentAssessmentExperimentAssignment = async (
  recordAssessmentExperimentAssignmentRequest?: RecordAssessmentExperimentAssignmentRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getRecordCurrentAssessmentExperimentAssignmentUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(recordAssessmentExperimentAssignmentRequest),
  });
};

export const getRecordCurrentAssessmentExperimentAssignmentMutationKey = () =>
  ["recordCurrentAssessmentExperimentAssignment"] as const;

export const getRecordCurrentAssessmentExperimentAssignmentMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>,
    TError,
    RecordCurrentAssessmentExperimentAssignmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>,
  TError,
  RecordCurrentAssessmentExperimentAssignmentMutationVariables,
  TContext
> => {
  const mutationKey = getRecordCurrentAssessmentExperimentAssignmentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>,
    RecordCurrentAssessmentExperimentAssignmentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recordCurrentAssessmentExperimentAssignment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordCurrentAssessmentExperimentAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>
>;
export type RecordCurrentAssessmentExperimentAssignmentMutationBody =
  | BodyType<RecordAssessmentExperimentAssignmentRequest>
  | undefined;
export type RecordCurrentAssessmentExperimentAssignmentMutationError = ErrorType<ProblemDetails>;
export type RecordCurrentAssessmentExperimentAssignmentMutationVariables = {
  data?: BodyType<RecordAssessmentExperimentAssignmentRequest>;
};

/**
 * @summary Records the variant the current assessment was bucketed into for an experiment. First-write-wins
per experiment; the accumulated set is stored on the assessment for later analysis.
 */
export const useRecordCurrentAssessmentExperimentAssignment = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>,
      TError,
      RecordCurrentAssessmentExperimentAssignmentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof recordCurrentAssessmentExperimentAssignment>>,
  TError,
  RecordCurrentAssessmentExperimentAssignmentMutationVariables,
  TContext
> => {
  return useMutation(
    getRecordCurrentAssessmentExperimentAssignmentMutationOptions(options),
    queryClient,
  );
};
export const getVerifyAssessmentTokenUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/verify`;
};

/**
 * @summary Verifies the assessment token is valid and returns the assessment ID.
 */
export const verifyAssessmentToken = async (
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  return retrieveData<void>(getVerifyAssessmentTokenUrl(), {
    ...options,
    method: "GET",
  });
};

export const getVerifyAssessmentTokenQueryKey = () => {
  return [`https://admin.ageless.ai/api/v1/ageless/assessments/verify`] as const;
};

export const getVerifyAssessmentTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyAssessmentToken>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof verifyAssessmentToken>>, TError, TData>
  >;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyAssessmentTokenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyAssessmentToken>>> = ({ signal }) =>
    verifyAssessmentToken({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyAssessmentToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type VerifyAssessmentTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyAssessmentToken>>
>;
export type VerifyAssessmentTokenQueryError = ErrorType<unknown>;

export function useVerifyAssessmentToken<
  TData = Awaited<ReturnType<typeof verifyAssessmentToken>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAssessmentToken>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyAssessmentToken>>,
          TError,
          Awaited<ReturnType<typeof verifyAssessmentToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifyAssessmentToken<
  TData = Awaited<ReturnType<typeof verifyAssessmentToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAssessmentToken>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyAssessmentToken>>,
          TError,
          Awaited<ReturnType<typeof verifyAssessmentToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifyAssessmentToken<
  TData = Awaited<ReturnType<typeof verifyAssessmentToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAssessmentToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Verifies the assessment token is valid and returns the assessment ID.
 */

export function useVerifyAssessmentToken<
  TData = Awaited<ReturnType<typeof verifyAssessmentToken>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAssessmentToken>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerifyAssessmentTokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetAssessmentPreScanInformationUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/pre-scan`;
};

/**
 * @summary Sets the pre-scan intake information — demographics, concerns, and goals — collected for an Ageless assessment before the photo scan step.
 */
export const setAssessmentPreScanInformation = async (
  assessmentId: string,
  setAssessmentPreScanInformationRequest?: SetAssessmentPreScanInformationRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentPreScanInformationUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentPreScanInformationRequest),
  });
};

export const getSetAssessmentPreScanInformationMutationKey = () =>
  ["setAssessmentPreScanInformation"] as const;

export const getSetAssessmentPreScanInformationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentPreScanInformation>>,
    TError,
    SetAssessmentPreScanInformationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentPreScanInformation>>,
  TError,
  SetAssessmentPreScanInformationMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentPreScanInformationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentPreScanInformation>>,
    SetAssessmentPreScanInformationMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentPreScanInformation(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentPreScanInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentPreScanInformation>>
>;
export type SetAssessmentPreScanInformationMutationBody =
  | BodyType<SetAssessmentPreScanInformationRequest>
  | undefined;
export type SetAssessmentPreScanInformationMutationError = ErrorType<unknown>;
export type SetAssessmentPreScanInformationMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentPreScanInformationRequest>;
};

/**
 * @summary Sets the pre-scan intake information — demographics, concerns, and goals — collected for an Ageless assessment before the photo scan step.
 */
export const useSetAssessmentPreScanInformation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentPreScanInformation>>,
      TError,
      SetAssessmentPreScanInformationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentPreScanInformation>>,
  TError,
  SetAssessmentPreScanInformationMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentPreScanInformationMutationOptions(options), queryClient);
};
export const getSetAssessmentPhotoDeviceInformationUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/photo-device-info`;
};

/**
 * @summary Sets the camera and device information captured for an Ageless assessment's photo step.
 */
export const setAssessmentPhotoDeviceInformation = async (
  assessmentId: string,
  setAssessmentPhotoDeviceInformationRequest?: SetAssessmentPhotoDeviceInformationRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentPhotoDeviceInformationUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentPhotoDeviceInformationRequest),
  });
};

export const getSetAssessmentPhotoDeviceInformationMutationKey = () =>
  ["setAssessmentPhotoDeviceInformation"] as const;

export const getSetAssessmentPhotoDeviceInformationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>,
    TError,
    SetAssessmentPhotoDeviceInformationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>,
  TError,
  SetAssessmentPhotoDeviceInformationMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentPhotoDeviceInformationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>,
    SetAssessmentPhotoDeviceInformationMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentPhotoDeviceInformation(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentPhotoDeviceInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>
>;
export type SetAssessmentPhotoDeviceInformationMutationBody =
  | BodyType<SetAssessmentPhotoDeviceInformationRequest>
  | undefined;
export type SetAssessmentPhotoDeviceInformationMutationError = ErrorType<unknown>;
export type SetAssessmentPhotoDeviceInformationMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentPhotoDeviceInformationRequest>;
};

/**
 * @summary Sets the camera and device information captured for an Ageless assessment's photo step.
 */
export const useSetAssessmentPhotoDeviceInformation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>,
      TError,
      SetAssessmentPhotoDeviceInformationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentPhotoDeviceInformation>>,
  TError,
  SetAssessmentPhotoDeviceInformationMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentPhotoDeviceInformationMutationOptions(options), queryClient);
};
export const getSetAssessmentContactInfoUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/contact-info`;
};

/**
 * @summary Sets the contact details, address, and consent preferences captured for an Ageless assessment.
 */
export const setAssessmentContactInfo = async (
  assessmentId: string,
  setAssessmentContactInfoRequest?: SetAssessmentContactInfoRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentContactInfoUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentContactInfoRequest),
  });
};

export const getSetAssessmentContactInfoMutationKey = () => ["setAssessmentContactInfo"] as const;

export const getSetAssessmentContactInfoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentContactInfo>>,
    TError,
    SetAssessmentContactInfoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentContactInfo>>,
  TError,
  SetAssessmentContactInfoMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentContactInfoMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentContactInfo>>,
    SetAssessmentContactInfoMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentContactInfo(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentContactInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentContactInfo>>
>;
export type SetAssessmentContactInfoMutationBody =
  | BodyType<SetAssessmentContactInfoRequest>
  | undefined;
export type SetAssessmentContactInfoMutationError = ErrorType<unknown>;
export type SetAssessmentContactInfoMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentContactInfoRequest>;
};

/**
 * @summary Sets the contact details, address, and consent preferences captured for an Ageless assessment.
 */
export const useSetAssessmentContactInfo = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentContactInfo>>,
      TError,
      SetAssessmentContactInfoMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentContactInfo>>,
  TError,
  SetAssessmentContactInfoMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentContactInfoMutationOptions(options), queryClient);
};
export const getSetAssessmentContextUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/context`;
};

/**
 * @summary Sets the usage context and location for the current Ageless assessment.
 */
export const setAssessmentContext = async (
  assessmentId: string,
  setAssessmentContextRequest?: SetAssessmentContextRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentContextUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentContextRequest),
  });
};

export const getSetAssessmentContextMutationKey = () => ["setAssessmentContext"] as const;

export const getSetAssessmentContextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentContext>>,
    TError,
    SetAssessmentContextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentContext>>,
  TError,
  SetAssessmentContextMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentContextMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentContext>>,
    SetAssessmentContextMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentContext(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentContext>>
>;
export type SetAssessmentContextMutationBody = BodyType<SetAssessmentContextRequest> | undefined;
export type SetAssessmentContextMutationError = ErrorType<unknown>;
export type SetAssessmentContextMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentContextRequest>;
};

/**
 * @summary Sets the usage context and location for the current Ageless assessment.
 */
export const useSetAssessmentContext = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentContext>>,
      TError,
      SetAssessmentContextMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentContext>>,
  TError,
  SetAssessmentContextMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentContextMutationOptions(options), queryClient);
};
export const getSetAssessmentStepByIdUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/step`;
};

/**
 * @summary Sets the current step of an in-progress Ageless assessment.
 */
export const setAssessmentStepById = async (
  assessmentId: string,
  setAssessmentStepByIdRequest?: SetAssessmentStepByIdRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentStepByIdUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentStepByIdRequest),
  });
};

export const getSetAssessmentStepByIdMutationKey = () => ["setAssessmentStepById"] as const;

export const getSetAssessmentStepByIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentStepById>>,
    TError,
    SetAssessmentStepByIdMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentStepById>>,
  TError,
  SetAssessmentStepByIdMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentStepByIdMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentStepById>>,
    SetAssessmentStepByIdMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentStepById(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentStepByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentStepById>>
>;
export type SetAssessmentStepByIdMutationBody = BodyType<SetAssessmentStepByIdRequest> | undefined;
export type SetAssessmentStepByIdMutationError = ErrorType<unknown>;
export type SetAssessmentStepByIdMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentStepByIdRequest>;
};

/**
 * @summary Sets the current step of an in-progress Ageless assessment.
 */
export const useSetAssessmentStepById = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentStepById>>,
      TError,
      SetAssessmentStepByIdMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentStepById>>,
  TError,
  SetAssessmentStepByIdMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentStepByIdMutationOptions(options), queryClient);
};
export const getSetCurrentAssessmentOriginalLanguageUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/current/original-language`;
};

/**
 * @summary Re-captures the current assessment's original language when the consumer switches the funnel
locale mid-session. The assessment is defined once per (subdomain, flow) with the locale of
the page it was born on, so a later locale switch must sync here before analysis generation
for the results to come back in the viewed language.
 */
export const setCurrentAssessmentOriginalLanguage = async (
  setAssessmentOriginalLanguageRequest?: SetAssessmentOriginalLanguageRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetCurrentAssessmentOriginalLanguageUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentOriginalLanguageRequest),
  });
};

export const getSetCurrentAssessmentOriginalLanguageMutationKey = () =>
  ["setCurrentAssessmentOriginalLanguage"] as const;

export const getSetCurrentAssessmentOriginalLanguageMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>,
    TError,
    SetCurrentAssessmentOriginalLanguageMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>,
  TError,
  SetCurrentAssessmentOriginalLanguageMutationVariables,
  TContext
> => {
  const mutationKey = getSetCurrentAssessmentOriginalLanguageMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>,
    SetCurrentAssessmentOriginalLanguageMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setCurrentAssessmentOriginalLanguage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCurrentAssessmentOriginalLanguageMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>
>;
export type SetCurrentAssessmentOriginalLanguageMutationBody =
  | BodyType<SetAssessmentOriginalLanguageRequest>
  | undefined;
export type SetCurrentAssessmentOriginalLanguageMutationError = ErrorType<ProblemDetails>;
export type SetCurrentAssessmentOriginalLanguageMutationVariables = {
  data?: BodyType<SetAssessmentOriginalLanguageRequest>;
};

/**
 * @summary Re-captures the current assessment's original language when the consumer switches the funnel
locale mid-session. The assessment is defined once per (subdomain, flow) with the locale of
the page it was born on, so a later locale switch must sync here before analysis generation
for the results to come back in the viewed language.
 */
export const useSetCurrentAssessmentOriginalLanguage = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>,
      TError,
      SetCurrentAssessmentOriginalLanguageMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setCurrentAssessmentOriginalLanguage>>,
  TError,
  SetCurrentAssessmentOriginalLanguageMutationVariables,
  TContext
> => {
  return useMutation(getSetCurrentAssessmentOriginalLanguageMutationOptions(options), queryClient);
};
export const getAcceptTransformationsForAssessmentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/accept-transformations`;
};

/**
 * @summary Records that the person accepted transformations for an assessment.
 */
export const acceptTransformationsForAssessment = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  return retrieveData<void>(getAcceptTransformationsForAssessmentUrl(assessmentId), {
    ...options,
    method: "POST",
  });
};

export const getAcceptTransformationsForAssessmentMutationKey = () =>
  ["acceptTransformationsForAssessment"] as const;

export const getAcceptTransformationsForAssessmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTransformationsForAssessment>>,
    TError,
    AcceptTransformationsForAssessmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTransformationsForAssessment>>,
  TError,
  AcceptTransformationsForAssessmentMutationVariables,
  TContext
> => {
  const mutationKey = getAcceptTransformationsForAssessmentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTransformationsForAssessment>>,
    AcceptTransformationsForAssessmentMutationVariables
  > = (props) => {
    const { assessmentId } = props ?? {};

    return acceptTransformationsForAssessment(assessmentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTransformationsForAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTransformationsForAssessment>>
>;

export type AcceptTransformationsForAssessmentMutationError = ErrorType<unknown>;
export type AcceptTransformationsForAssessmentMutationVariables = { assessmentId: string };

/**
 * @summary Records that the person accepted transformations for an assessment.
 */
export const useAcceptTransformationsForAssessment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptTransformationsForAssessment>>,
      TError,
      AcceptTransformationsForAssessmentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptTransformationsForAssessment>>,
  TError,
  AcceptTransformationsForAssessmentMutationVariables,
  TContext
> => {
  return useMutation(getAcceptTransformationsForAssessmentMutationOptions(options), queryClient);
};
export const getSetAssessmentSelectedTreatmentsUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/treatments`;
};

/**
 * @summary Sets the treatments selected for an Ageless assessment and returns the resulting session IDs.
 */
export const setAssessmentSelectedTreatments = async (
  assessmentId: string,
  setAssessmentSelectedTreatmentsRequest?: SetAssessmentSelectedTreatmentsRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getSetAssessmentSelectedTreatmentsUrl(assessmentId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setAssessmentSelectedTreatmentsRequest),
  });
};

export const getSetAssessmentSelectedTreatmentsMutationKey = () =>
  ["setAssessmentSelectedTreatments"] as const;

export const getSetAssessmentSelectedTreatmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>,
    TError,
    SetAssessmentSelectedTreatmentsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>,
  TError,
  SetAssessmentSelectedTreatmentsMutationVariables,
  TContext
> => {
  const mutationKey = getSetAssessmentSelectedTreatmentsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>,
    SetAssessmentSelectedTreatmentsMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return setAssessmentSelectedTreatments(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAssessmentSelectedTreatmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>
>;
export type SetAssessmentSelectedTreatmentsMutationBody =
  | BodyType<SetAssessmentSelectedTreatmentsRequest>
  | undefined;
export type SetAssessmentSelectedTreatmentsMutationError = ErrorType<unknown>;
export type SetAssessmentSelectedTreatmentsMutationVariables = {
  assessmentId: string;
  data?: BodyType<SetAssessmentSelectedTreatmentsRequest>;
};

/**
 * @summary Sets the treatments selected for an Ageless assessment and returns the resulting session IDs.
 */
export const useSetAssessmentSelectedTreatments = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>,
      TError,
      SetAssessmentSelectedTreatmentsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAssessmentSelectedTreatments>>,
  TError,
  SetAssessmentSelectedTreatmentsMutationVariables,
  TContext
> => {
  return useMutation(getSetAssessmentSelectedTreatmentsMutationOptions(options), queryClient);
};
export const getRetrieveFutureSelfImageUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/future-photos/without-treatments`;
};

/**
 * @summary Retrieve the future self image without treatments for an Ageless Assessment.
Returns the generated image URL if available, or 404 if not yet generated.
 */
export const retrieveFutureSelfImage = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<RetrieveAssessmentFuturePhotoResponse> => {
  return retrieveData<RetrieveAssessmentFuturePhotoResponse>(
    getRetrieveFutureSelfImageUrl(assessmentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveFutureSelfImageQueryKey = (assessmentId: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/future-photos/without-treatments`,
  ] as const;
};

export const getRetrieveFutureSelfImageQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveFutureSelfImageQueryKey(assessmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveFutureSelfImage>>> = ({
    signal,
  }) => retrieveFutureSelfImage(assessmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RetrieveFutureSelfImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFutureSelfImage>>
>;
export type RetrieveFutureSelfImageQueryError = ErrorType<unknown>;

export function useRetrieveFutureSelfImage<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
          TError,
          Awaited<ReturnType<typeof retrieveFutureSelfImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveFutureSelfImage<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
          TError,
          Awaited<ReturnType<typeof retrieveFutureSelfImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveFutureSelfImage<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve the future self image without treatments for an Ageless Assessment.
Returns the generated image URL if available, or 404 if not yet generated.
 */

export function useRetrieveFutureSelfImage<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImage>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveFutureSelfImage>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveFutureSelfImageQueryOptions(assessmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveFutureSelfImageWithTreatmentsUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/future-photos/with-treatments`;
};

/**
 * @summary Retrieve the future self image with treatments for an Ageless Assessment.
Returns the generated image URL if available, or 404 if not yet generated.
 */
export const retrieveFutureSelfImageWithTreatments = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<RetrieveAssessmentFuturePhotoResponse> => {
  return retrieveData<RetrieveAssessmentFuturePhotoResponse>(
    getRetrieveFutureSelfImageWithTreatmentsUrl(assessmentId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveFutureSelfImageWithTreatmentsQueryKey = (assessmentId: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/future-photos/with-treatments`,
  ] as const;
};

export const getRetrieveFutureSelfImageWithTreatmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveFutureSelfImageWithTreatmentsQueryKey(assessmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>
  > = ({ signal }) =>
    retrieveFutureSelfImageWithTreatments(assessmentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveFutureSelfImageWithTreatmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>
>;
export type RetrieveFutureSelfImageWithTreatmentsQueryError = ErrorType<unknown>;

export function useRetrieveFutureSelfImageWithTreatments<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
          TError,
          Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveFutureSelfImageWithTreatments<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
          TError,
          Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveFutureSelfImageWithTreatments<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve the future self image with treatments for an Ageless Assessment.
Returns the generated image URL if available, or 404 if not yet generated.
 */

export function useRetrieveFutureSelfImageWithTreatments<
  TData = Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveFutureSelfImageWithTreatments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveFutureSelfImageWithTreatmentsQueryOptions(assessmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMarkAssessmentResultsViewedByTakerUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/mark-results-viewed-by-taker`;
};

/**
 * @summary Marks that the assessment results were viewed by the taker.
 */
export const markAssessmentResultsViewedByTaker = async (
  assessmentId: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  return retrieveData<void>(getMarkAssessmentResultsViewedByTakerUrl(assessmentId), {
    ...options,
    method: "POST",
  });
};

export const getMarkAssessmentResultsViewedByTakerMutationKey = () =>
  ["markAssessmentResultsViewedByTaker"] as const;

export const getMarkAssessmentResultsViewedByTakerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>,
    TError,
    MarkAssessmentResultsViewedByTakerMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>,
  TError,
  MarkAssessmentResultsViewedByTakerMutationVariables,
  TContext
> => {
  const mutationKey = getMarkAssessmentResultsViewedByTakerMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>,
    MarkAssessmentResultsViewedByTakerMutationVariables
  > = (props) => {
    const { assessmentId } = props ?? {};

    return markAssessmentResultsViewedByTaker(assessmentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAssessmentResultsViewedByTakerMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>
>;

export type MarkAssessmentResultsViewedByTakerMutationError = ErrorType<unknown>;
export type MarkAssessmentResultsViewedByTakerMutationVariables = { assessmentId: string };

/**
 * @summary Marks that the assessment results were viewed by the taker.
 */
export const useMarkAssessmentResultsViewedByTaker = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>,
      TError,
      MarkAssessmentResultsViewedByTakerMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAssessmentResultsViewedByTaker>>,
  TError,
  MarkAssessmentResultsViewedByTakerMutationVariables,
  TContext
> => {
  return useMutation(getMarkAssessmentResultsViewedByTakerMutationOptions(options), queryClient);
};
export const getBookConsultationUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/book-consultation`;
};

/**
 * @summary Requests a consultation for an assessment.
 */
export const bookConsultation = async (
  assessmentId: string,
  requestConsultationForAssessmentRequest?: RequestConsultationForAssessmentRequest,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getBookConsultationUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(requestConsultationForAssessmentRequest),
  });
};

export const getBookConsultationMutationKey = () => ["bookConsultation"] as const;

export const getBookConsultationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookConsultation>>,
    TError,
    BookConsultationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bookConsultation>>,
  TError,
  BookConsultationMutationVariables,
  TContext
> => {
  const mutationKey = getBookConsultationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bookConsultation>>,
    BookConsultationMutationVariables
  > = (props) => {
    const { assessmentId, data } = props ?? {};

    return bookConsultation(assessmentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BookConsultationMutationResult = NonNullable<
  Awaited<ReturnType<typeof bookConsultation>>
>;
export type BookConsultationMutationBody =
  | BodyType<RequestConsultationForAssessmentRequest>
  | undefined;
export type BookConsultationMutationError = ErrorType<unknown>;
export type BookConsultationMutationVariables = {
  assessmentId: string;
  data?: BodyType<RequestConsultationForAssessmentRequest>;
};

/**
 * @summary Requests a consultation for an assessment.
 */
export const useBookConsultation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bookConsultation>>,
      TError,
      BookConsultationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bookConsultation>>,
  TError,
  BookConsultationMutationVariables,
  TContext
> => {
  return useMutation(getBookConsultationMutationOptions(options), queryClient);
};
export const getCaptureBookingCtaClickUrl = (
  assessmentId: string,
  params?: CaptureBookingCtaClickParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/booking-cta-clicked?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/booking-cta-clicked`;
};

/**
 * @summary Captures a booking call-to-action click for an Ageless assessment, tagged with its click source.
 */
export const captureBookingCtaClick = async (
  assessmentId: string,
  params?: CaptureBookingCtaClickParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<void> => {
  return retrieveData<void>(getCaptureBookingCtaClickUrl(assessmentId, params), {
    ...options,
    method: "POST",
  });
};

export const getCaptureBookingCtaClickMutationKey = () => ["captureBookingCtaClick"] as const;

export const getCaptureBookingCtaClickMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureBookingCtaClick>>,
    TError,
    CaptureBookingCtaClickMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof captureBookingCtaClick>>,
  TError,
  CaptureBookingCtaClickMutationVariables,
  TContext
> => {
  const mutationKey = getCaptureBookingCtaClickMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof captureBookingCtaClick>>,
    CaptureBookingCtaClickMutationVariables
  > = (props) => {
    const { assessmentId, params } = props ?? {};

    return captureBookingCtaClick(assessmentId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaptureBookingCtaClickMutationResult = NonNullable<
  Awaited<ReturnType<typeof captureBookingCtaClick>>
>;

export type CaptureBookingCtaClickMutationError = ErrorType<unknown>;
export type CaptureBookingCtaClickMutationVariables = {
  assessmentId: string;
  params?: CaptureBookingCtaClickParams;
};

/**
 * @summary Captures a booking call-to-action click for an Ageless assessment, tagged with its click source.
 */
export const useCaptureBookingCtaClick = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof captureBookingCtaClick>>,
      TError,
      CaptureBookingCtaClickMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof captureBookingCtaClick>>,
  TError,
  CaptureBookingCtaClickMutationVariables,
  TContext
> => {
  return useMutation(getCaptureBookingCtaClickMutationOptions(options), queryClient);
};
export const getGenerateAfterImageUrl = (aiProviderName: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/assessments/generate-after-image/${aiProviderName}`;
};

/**
 * @summary Generates an AI-modified after-treatment preview image from an uploaded photo using the specified AI provider.
 */
export const generateAfterImage = async (
  aiProviderName: string,
  generateAfterImageBody?: GenerateAfterImageBody,
  options?: Parameters<typeof retrieveData>[1],
): Promise<string> => {
  const formData = new FormData();
  if (generateAfterImageBody?.File !== undefined) {
    formData.append(`File`, generateAfterImageBody.File);
  }
  if (generateAfterImageBody?.Goals !== undefined) {
    generateAfterImageBody?.Goals.forEach((value) => formData.append(`Goals`, value));
  }

  return retrieveData<string>(getGenerateAfterImageUrl(aiProviderName), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getGenerateAfterImageMutationKey = () => ["generateAfterImage"] as const;

export const getGenerateAfterImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAfterImage>>,
    TError,
    GenerateAfterImageMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAfterImage>>,
  TError,
  GenerateAfterImageMutationVariables,
  TContext
> => {
  const mutationKey = getGenerateAfterImageMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAfterImage>>,
    GenerateAfterImageMutationVariables
  > = (props) => {
    const { aiProviderName, data } = props ?? {};

    return generateAfterImage(aiProviderName, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAfterImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAfterImage>>
>;
export type GenerateAfterImageMutationBody = BodyType<GenerateAfterImageBody> | undefined;
export type GenerateAfterImageMutationError = ErrorType<unknown>;
export type GenerateAfterImageMutationVariables = {
  aiProviderName: string;
  data?: BodyType<GenerateAfterImageBody>;
};

/**
 * @summary Generates an AI-modified after-treatment preview image from an uploaded photo using the specified AI provider.
 */
export const useGenerateAfterImage = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateAfterImage>>,
      TError,
      GenerateAfterImageMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateAfterImage>>,
  TError,
  GenerateAfterImageMutationVariables,
  TContext
> => {
  return useMutation(getGenerateAfterImageMutationOptions(options), queryClient);
};
export const getRetrieveWellnessRecommendationsUrl = (
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/wellness-recommendations?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/wellness-recommendations`;
};

/**
 * @summary Retrieves enriched wellness treatment recommendations for an assessment,
with server-side name/pricing resolution and visibility filtering.
 */
export const retrieveWellnessRecommendations = async (
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayWellnessRecommendationsForAssessmentResponse> => {
  return retrieveData<DisplayWellnessRecommendationsForAssessmentResponse>(
    getRetrieveWellnessRecommendationsUrl(assessmentId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveWellnessRecommendationsQueryKey = (
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/wellness-recommendations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWellnessRecommendationsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveWellnessRecommendationsQueryKey(assessmentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>> = ({
    signal,
  }) => retrieveWellnessRecommendations(assessmentId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWellnessRecommendationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWellnessRecommendations>>
>;
export type RetrieveWellnessRecommendationsQueryError = ErrorType<unknown>;

export function useRetrieveWellnessRecommendations<
  TData = Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params: undefined | RetrieveWellnessRecommendationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
          TError,
          Awaited<ReturnType<typeof retrieveWellnessRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveWellnessRecommendations<
  TData = Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
          TError,
          Awaited<ReturnType<typeof retrieveWellnessRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveWellnessRecommendations<
  TData = Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves enriched wellness treatment recommendations for an assessment,
with server-side name/pricing resolution and visibility filtering.
 */

export function useRetrieveWellnessRecommendations<
  TData = Awaited<ReturnType<typeof retrieveWellnessRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveWellnessRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveWellnessRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveWellnessRecommendationsQueryOptions(
    assessmentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetrieveAestheticRecommendationsUrl = (
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/aesthetic-recommendations?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/aesthetic-recommendations`;
};

/**
 * @summary Retrieves enriched aesthetic treatment recommendations for an assessment,
with server-side name/pricing resolution and visibility filtering.
 */
export const retrieveAestheticRecommendations = async (
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAestheticRecommendationsForAssessmentResponse> => {
  return retrieveData<DisplayAestheticRecommendationsForAssessmentResponse>(
    getRetrieveAestheticRecommendationsUrl(assessmentId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getRetrieveAestheticRecommendationsQueryKey = (
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/assessments/${assessmentId}/aesthetic-recommendations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveAestheticRecommendationsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveAestheticRecommendationsQueryKey(assessmentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>> = ({
    signal,
  }) => retrieveAestheticRecommendations(assessmentId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: assessmentId !== null && assessmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveAestheticRecommendationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveAestheticRecommendations>>
>;
export type RetrieveAestheticRecommendationsQueryError = ErrorType<unknown>;

export function useRetrieveAestheticRecommendations<
  TData = Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params: undefined | RetrieveAestheticRecommendationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
          TError,
          Awaited<ReturnType<typeof retrieveAestheticRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAestheticRecommendations<
  TData = Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
          TError,
          Awaited<ReturnType<typeof retrieveAestheticRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetrieveAestheticRecommendations<
  TData = Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves enriched aesthetic treatment recommendations for an assessment,
with server-side name/pricing resolution and visibility filtering.
 */

export function useRetrieveAestheticRecommendations<
  TData = Awaited<ReturnType<typeof retrieveAestheticRecommendations>>,
  TError = ErrorType<unknown>,
>(
  assessmentId: string,
  params?: RetrieveAestheticRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveAestheticRecommendations>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetrieveAestheticRecommendationsQueryOptions(
    assessmentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
